<script lang="ts" setup>
import { app } from '@/composition/app'
import { GroupState } from '@/composition/groups'
import { TimeFrame } from '@/models/Leaderboard'
import { UIContentWrap } from '@gohighlevel/ghl-ui'
import { onMounted, onUnmounted, ref } from 'vue'

import InfoList from '@/components/InfoList.vue'
import GroupInfo from '@/components/groups/GroupInfoIndex.vue'
import LeaderboardTable from '@/components/leaderboard/web/LeaderboardTable.vue'
import Posts from '@/components/posts/Posts.vue'
import { useRouter } from 'vue-router'

const router = useRouter()
onMounted(() => {
  if (GroupState.state?.noCommunities) {
    router.push({ name: 'no-communities-mobile' })
  }

  window.scrollTo(0, 0)
  setTimeout(handleStickyScroll, 1000)
  window.addEventListener('scroll', handleStickyScroll)
})
const groupInfoRef = ref()
function handleStickyScroll() {
  const groupInfoElement = groupInfoRef.value
  if (groupInfoElement) {
    const rect = groupInfoElement.getBoundingClientRect()
    // positive values of top are not required
    GroupState.state.groupInfoTopPosition = Math.min(
      130,
      window.innerHeight - rect.bottom + rect.top - 10
    )
    groupInfoElement.style.top = `${GroupState.state.groupInfoTopPosition}px`
  } else {
    setTimeout(handleStickyScroll, 3000)
  }
}

onUnmounted(() => {
  window.removeEventListener('scroll', handleStickyScroll)
})
</script>
<template>
  <div
    v-if="!app.state.isMobile"
    id="container_group_discussion"
    class="grid grid-cols-6 justify-center gap-5"
  >
    <transition name="fade">
      <div id="post_list" class="sticky_scroll col-span-4">
        <Posts />
      </div>
    </transition>

    <transition name="fade">
      <div
        id="group_info"
        ref="groupInfoRef"
        class="sidebar sticky_scroll right col-span-2 h-fit pb-5"
      >
        <InfoList class="sidebar col-span-2">
          <template #info-details>
            <GroupInfo />
          </template>
        </InfoList>
        <LeaderboardTable
          :timeframe="TimeFrame.THIRTY_DAY"
          :row-limit="5"
          :is-info-card="true"
          class="mt-5"
        />
      </div>
    </transition>
  </div>
  <UIContentWrap
    v-else
    class="outer-container full-screen lg:mobile-padding bg-communities-surface pb-2 lg:px-3"
  >
    <div
      class="mobile-content-container relative grid-cols-1 gap-4 lg:grid lg:grid-cols-10 xl:grid-cols-36 xl:gap-5"
    >
      <transition name="fade">
        <Posts class="md:col-span-17 lg:col-span-8 xl:col-span-20" />
      </transition>
    </div>
  </UIContentWrap>
</template>
<style scoped>
.sticky_scroll {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: sticky;
}

html,
body {
  position: relative;
  margin: 0;
  border: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
body {
  overflow: auto;
}
.group__info {
  width: 300px;
}
/* .posts {
  min-width: 555px;
  max-width: 760px;
}*/

.mobile-content-container {
  height: calc(100vh - 46.8px);
}

.sidebar {
  min-width: 250px;
}

@media (max-width: 930px) {
  .outer-container {
    padding: 0px !important;
    padding-bottom: 75px !important;
  }
}
.hl-wrapper-container {
  padding: 0px !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
